export default function (session) {
  if (new Date(session.lastMsg.time).toDateString() === new Date().toDateString()) {
    session.lastMsg.isToday = true
  } else if (isYestday(new Date(session.lastMsg.time))) {
    session.lastMsg.isYestday = true
  }
  session.lastMsgTime = session.lastMsg.time
}

function isYestday(theDate) {
  var date = (new Date())
  var today = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  var yestday = new Date(today - 24 * 3600 * 1000).getTime()
  return theDate.getTime() < today && yestday <= theDate.getTime()
}

export function formatterDate(dateString) {
  if (!dateString) {
    return
  }
  var date = new Date(dateString);
  var year = date.getFullYear();

  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export function formatterNow() {
  var date = new Date();
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}



// WEBPACK FOOTER //
// ./src/services/formatTime.js